<div class="diff-header">
  <p class="diff-title">{{ title }}</p>
</div>
<div class="diff-container">
  <div class="diff-lines">
    <div
      *ngFor="let line of diffLines; trackBy: trackByLineNumber"
      class="diff-line"
      [ngClass]="{
        'diff-line-added': line.type === 'added',
        'diff-line-removed': line.type === 'removed',
        'diff-line-unchanged': line.type === 'unchanged'
      }"
    >
      <span class="diff-prefix" *ngIf="line.type === 'added'">+</span>
      <span class="diff-prefix" *ngIf="line.type === 'removed'">-</span>
      <span class="diff-prefix" *ngIf="line.type === 'unchanged'">&nbsp;</span>
      <span class="diff-content">{{ line.content }}</span>
    </div>
  </div>
</div>
